// extracted by mini-css-extract-plugin
export var avatarContainer = "_3g-0";
export var largeAvatarContainer = "_3g-1";